/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Strava_ConnectInputs */

const en_us2_native_release_strava_connect = /** @type {(inputs: Native_Release_Strava_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Strava`)
};

const pt_br2_native_release_strava_connect = /** @type {(inputs: Native_Release_Strava_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar Strava`)
};

const pt_pt2_native_release_strava_connect = /** @type {(inputs: Native_Release_Strava_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar Strava`)
};

/** @type {(inputs: Native_Release_Strava_ConnectInputs) => LocalizedString} */
const es_419_native_release_strava_connect = en_us2_native_release_strava_connect;

/** @type {(inputs: Native_Release_Strava_ConnectInputs) => LocalizedString} */
const fr_fr2_native_release_strava_connect = en_us2_native_release_strava_connect;

/** @type {(inputs: Native_Release_Strava_ConnectInputs) => LocalizedString} */
const de_de2_native_release_strava_connect = en_us2_native_release_strava_connect;

/** @type {(inputs: Native_Release_Strava_ConnectInputs) => LocalizedString} */
const it_it2_native_release_strava_connect = en_us2_native_release_strava_connect;

/**
* | output |
* | --- |
* | "Connect Strava" |
*
* @param {Native_Release_Strava_ConnectInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_strava_connect = /** @type {((inputs?: Native_Release_Strava_ConnectInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Strava_ConnectInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_strava_connect(inputs)
	if (locale === "es-419") return es_419_native_release_strava_connect(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_strava_connect(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_strava_connect(inputs)
	if (locale === "de-DE") return de_de2_native_release_strava_connect(inputs)
	if (locale === "it-IT") return it_it2_native_release_strava_connect(inputs)
	return en_us2_native_release_strava_connect(inputs)
});
export { native_release_strava_connect as "native-release.strava_connect" }